<template>
  <page-outline :title="$t('common.alerts.alerts_history')">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start">
          <b-col cols="4" lg="2" xl="2" class="mb-5">
            <b-button class="btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="2" class="mb-5">
            <b-button class="btnFilter"
              :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="min-w-100 justify-content-start" :class="{'filter-item-section':true, 'd-none': !displayFilter}">
          <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
            <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
              :class="{'filter-item-input': true, 'filter-item-input-complete': dateStart}"
              :inputLabel="$t('common.alerts.date_start')"
              customInputParentClass="filter-item-content"
              customInputClass="w-100"
              :maxLength="19"
              :placeholderValue="$t('common.datetime_picker_empty_date')"
              inputIcon="fa-solid fa-calendar"
              v-model="dateStart">
            </datetime-picker-custom>
          </b-col>
          <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
            <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
              :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}"
              :inputLabel="$t('common.alerts.date_end')"
              customInputParentClass="filter-item-content"
              customInputClass="w-100"
              :maxLength="19"
              :placeholderValue="$t('common.datetime_picker_empty_date')"
              inputIcon="fa-solid fa-calendar"
              v-model="dateEnd">
            </datetime-picker-custom>
          </b-col>
          <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
            <label for="alert-select-criticality">
              {{ $t('common.alerts.criticality_level') }}
            </label>
            <select class="form-control min-w-100" v-model="criticality" id="alert-select-criticality">
              <option value="" disabled>{{ $t('common.alerts.select_criticality_level_placeholder') }}</option>
              <option value="CRITICAL">{{ $t('common.alerts.critical') }}</option>
              <option value="HIGH">{{ $t('common.alerts.high') }}</option>
              <option value="MEDIUM">{{ $t('common.alerts.medium') }}</option>
              <option value="LOW">{{ $t('common.alerts.low') }}</option>
            </select>
          </b-col>
          <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5">
            <label for="alert-select-status">
              {{ $t('common.alerts.status') }}
            </label>
            <select class="form-control min-w-100" v-model="status" id="alert-select-status">
              <option value="" disabled>{{ $t('common.alerts.select_status_placeholder') }}</option>
              <option value="0">{{ $t('common.alerts.status_solved') }}</option>
              <option value="1">{{ $t('common.alerts.status_on_going') }}</option>
            </select>
          </b-col>
        </b-row>
        <b-row class="justify-content-end" v-if="displayFilter">
          <!-- Boutons Effacer et Appliquer -->
          <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
            <b-button class="mr-3" size="sm"
              @click="clearFilterFields">
              {{ $t('filter.clr_fltr_field') }}
            </b-button>
          </b-col>
          <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
            <b-button class="btn" size="sm"
              @click="onRefresh">
              {{ $t('common.srch') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col>
            <div style="overflow:auto">
              <spinner v-if="activateSpinner"></spinner>
              <b-table responsive
                v-else-if="alertsHistoryList.length"
                class="mt-3 table-striped"
                :items="alertsHistoryList"
                :fields="alertsHistoryFields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable">
                <template #cell(MetricsKey)="data">
                  <span>{{ $t('common.monitoring.key.' + data.value) }}</span>
                </template>
                <template #cell(ThresholdStatus)="data">
                  <span>{{ $t('common.alerts.threshold_status_value.'+data.value) }}</span>
                </template>
                <template #cell(DateStart)="data">
                  <span>{{ getDate(data.value) }}</span>
                </template>
                <template #cell(DateEnd)="data">
                  <span>{{ getDate(data.value) }}</span>
                </template>
                <template #cell(Criticality)="data">
                  <i v-if="translateCriticalityFromDatabase(data.value) == 'LOW'" class="fa-solid fa-circle color-light-blue" ></i>
                  <i v-if="translateCriticalityFromDatabase(data.value) == 'MEDIUM'" class="fa-solid fa-circle color-yellow" ></i>
                  <i v-if="translateCriticalityFromDatabase(data.value) == 'HIGH'" class="fa-solid fa-circle color-orange" ></i>
                  <i v-if="translateCriticalityFromDatabase(data.value) == 'CRITICAL'" class="fa-solid fa-circle color-red" ></i>
                  <span>{{ $t('common.alerts.' + translateCriticalityFromDatabase(data.value)) }}</span>
                </template>
                <template #cell(status)="data">
                  <i v-if="data.value == 0" class="fa-regular fa-circle-check color-lime-green" ></i>
                  <i v-if="data.value == 1" class="fa-regular fa-circle-xmark text-danger" ></i>
                </template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <cm-pagination
              :maxResultsByPage="paginationObject.maxResults"
              :firstIndex="paginationObject.firstIndex"
              :nbResultsTotal="paginationObject.nbResultsTotal"
              :refreshEvent="paginationObject.refresh">
            </cm-pagination>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import Pagination from '@/components/common/pagination.vue'
import moment from 'moment'
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import {errorMessageAlert} from '@/helpers/alert'
import { loadPage } from "@/helpers/routing"

export default {
  name: "AlertsPage",
  components: {
    'cm-pagination': Pagination,
    'datetime-picker-custom': dateTimePicker,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  computed: {
  },
  data() {
    return {
      activateSpinner: false,
      alertsHistoryList: [],
      alertsHistoryFields: [],
      criticality: '',
      dateEnd: '',
      dateStart: '',
      displayFilter: false,
      filterConditions: {},
      pageCounter: 0,
      paginationObject: {},
      sortBy: '',
      sortDir: false,
      status: ''
    }
  },
  created() {
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }

    this.activateSpinner = true
    this.alertsHistoryFields = [
      { key: 'AlertName', label: this.$t('common.alerts.name'), class: 'text-center', sortable: true },
      { key: 'IdPod', label: this.$t('common.alerts.pod'), class: 'text-center', sortable: true },
      { key: 'MetricsKey', label: this.$t('common.alerts.metrics_key'), class: 'text-center', sortable: true },
      { key: 'ThresholdStatus', label: this.$t('common.alerts.threshold_status'), class: 'text-center', sortable: true },
      { key: 'DateStart', label: this.$t('common.alerts.date_start'), class: 'text-center', sortable: true },
      { key: 'DateEnd', label: this.$t('common.alerts.date_end'), class: 'text-center', sortable: true },
      { key: 'Criticality', label: this.$t('common.alerts.criticality_level'), class: 'text-center', sortable: true },
      { key: 'Status', label: this.$t('common.alerts.status'), class: 'text-center', sortable: true }
    ]

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getAlertsHistory(index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.getAlertsHistory()
  },
  computed: {
  },
  methods: {
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getAlertsHistory()
    },
    clearFilterFields() {
      this.criticality = ''
      this.dateEnd = ''
      this.dateStart = ''
      this.status = ''
      // this.applyFilter()
    },
    /*colorLineByCriticality(item, type) {
      if (!item || type !== "row") return;
      return;
      switch (this.translateCriticalityFromDatabase(item.Criticality)) {
        case "LOW":
          return "row-criticality-low";
        case "MEDIUM":
          return "row-criticality-medium";
        case "HIGH":
          return "row-criticality-high";
        case "CRITICAL":
          return "row-criticality-critical";
        default:
          return "";
      }
    },*/
    getAlertsHistory(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      let params = {
        Status: this.status,
        Criticality: this.translateCriticalityToDatabase(this.criticality),
        DateStart: this.dateStart,
        DateEnd: this.dateEnd,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.alerts.getHistory(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.AlertsHistoryList.length

        that.alertsHistoryList = resp.data.AlertsHistoryList
        that.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getDate (date) {
      if (date != ''){
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss')
      }
      else {
        return '-'
      }
    },
    onRefresh() {
      this.activateSpinner = true
      this.getAlertsHistory()
    },
    sortTable (key, field, event, isFooter) {
      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    translateCriticalityFromDatabase(criticality) {
      if (criticality === '0') {
        return "LOW"
      } else if (criticality === '1') {
        return "MEDIUM"
      } else if (criticality === '2') {
        return "HIGH"
      } else if (criticality === '3') {
        return "CRITICAL"
      } else {
        return ''
      }
    },
    translateCriticalityToDatabase(criticality) {
      if (criticality === "LOW") {
        return '0'
      } else if (criticality === "MEDIUM") {
        return '1'
      } else if (criticality === "HIGH") {
        return '2'
      } else if (criticality === "CRITICAL") {
        return '3'
      } else {
        return ''
      }
    },
    translateMetricKey(key) {
        if (key.includes("Connecteur")) {
          return this.$t('common.alerts.' + key.replace(' ', ''))
        } else {
          return key
        }
    }
  }
}
</script></script>
